import React, { useContext } from 'react';
import cn from 'classnames';
import { string } from 'prop-types';
import Link from '../../atoms/Link';
import PopupContext from '../../context/PopupContext';
import PopupBackdrop from '../../atoms/PopupBackdrop';

var _ref2 = /*#__PURE__*/React.createElement("div", {
  className: "auth-drop-down__separator"
});

var AuthDropDown = function AuthDropDown(_ref) {
  var className = _ref.className,
      signInUrl = _ref.signInUrl,
      registerUrl = _ref.registerUrl;

  var _useContext = useContext(PopupContext),
      activePopup = _useContext.activePopup,
      popupKeys = _useContext.popupKeys;

  var open = activePopup === popupKeys.account;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "".concat(popupKeys.account, "-popup"),
    className: cn('auth-drop-down', className, open && 'auth-drop-down--open')
  }, /*#__PURE__*/React.createElement(Link, {
    href: signInUrl,
    className: "auth-drop-down__link"
  }, "Sign in"), _ref2, /*#__PURE__*/React.createElement(Link, {
    href: registerUrl,
    className: "auth-drop-down__link"
  }, "Register")), /*#__PURE__*/React.createElement(PopupBackdrop, {
    active: open,
    className: "auth-drop-down__backdrop"
  }));
};

AuthDropDown.defaultProps = {
  className: null
};
AuthDropDown.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** The URL to navigate to for signing in. */
  signInUrl: string.isRequired,

  /** The URL to navigate to for registering. */
  registerUrl: string.isRequired
} : {};
export default AuthDropDown;